module.exports = __webpack_public_path__ + "fonts/merriweather-v19-latin_latin-ext-700.8d62929a.woff2";